export interface RelativePeriodDropdownOption {
  label?: string;
  value: RelativePeriod;
}

export enum RelativePeriod {
  PreviousYearCurrentPeriod = 'PreviousYearCurrentPeriod',
  PreviousPeriod = 'PreviousPeriod',
}

export enum RelativePeriodLabel {
  PreviousYearCurrentPeriod = 'vs Same period last year',
  PreviousPeriod = 'vs Previous period',
}

export enum RelativePeriodLabel2 {
  PreviousYearCurrentPeriod = 'Same period last year',
  PreviousPeriod = 'Previous period',
}

export const RelativePeriodMapping: Record<RelativePeriod, RelativePeriodLabel> = {
  [RelativePeriod.PreviousYearCurrentPeriod]: RelativePeriodLabel.PreviousYearCurrentPeriod,
  [RelativePeriod.PreviousPeriod]: RelativePeriodLabel.PreviousPeriod,
};

export const RelativePeriodMapping2: Record<RelativePeriod, RelativePeriodLabel2> = {
  [RelativePeriod.PreviousYearCurrentPeriod]: RelativePeriodLabel2.PreviousYearCurrentPeriod,
  [RelativePeriod.PreviousPeriod]: RelativePeriodLabel2.PreviousPeriod,
};

enum BackendComparisonPeriodType {
  PreviousYearCurrentPeriod = 'SAME_PERIOD_LAST_YEAR',
  PreviousPeriod = 'PREVIOUS_PERIOD',
}

export const BackendComparisonPeriodTypeMapping: Record<
  RelativePeriod,
  BackendComparisonPeriodType
> = {
  [RelativePeriod.PreviousYearCurrentPeriod]: BackendComparisonPeriodType.PreviousYearCurrentPeriod,
  [RelativePeriod.PreviousPeriod]: BackendComparisonPeriodType.PreviousPeriod,
};
